<template>
  <div class="column">
    <div class="notification">
      <a v-show="mode === 'grid'" class="delete" @click="$emit('close')"></a>

      <template v-if="canEdit">
        <tip-tap-editor :initial-content="text && text.length ? text : '<p></p>'" @update:content="update"></tip-tap-editor>
        <hr>

        <save-buttons
          @save="save"
          :noCancel="true">
        </save-buttons>
      </template>

      <div v-else class="content" v-html="text"></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { authMixin } from '@/mixins'
import SaveButtons from '@/components/modules/SaveButtons'
import TipTapEditor from "@/components/modules/TipTapEditor.vue";

export default {
  name: 'PageGeneralText',
  props: {
    pageId: {
      type: Number,
      required: true
    },
    bundleId: {
      type: Number,
      required: true
    }
  },
  components: {
    TipTapEditor,
    // Rte,
    SaveButtons
  },
  mixins: [
    authMixin
  ],
  data () {
    return {
      text: null
    }
  },
  computed: {
    ...mapGetters({
      auth: 'account/auth',
      page: 'pages/page',
      mode: 'pages/mode',
      account: 'account/account',
      isAuthorised: 'users/isAuthorised'
    }),
    canEdit () {
      return (this.isAdmin(this.account) || this.inScope(this.account, 14)) && this.isAuthorised
    }
  },
  created () {
    this.text = (this.page.page_texts[0]) ? this.page.page_texts[0].text : ''
  },
  methods: {
    update (payload) {
      this.text = payload
    },
    save () {
      this.$store.dispatch('pages/saveText', {
        pageId: this.page.id,
        bundleId: this.$route.params.bundleId,
        text: this.text
      })

      // this.editing = false
      this.$emit('close')
    }
  }
}
</script>

<style scoped>

</style>
